//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    sku: { type: String, required: true },
    secondarySku: { type: String, required: true },
    frameType: { type: String, required: true },
    conversionKitEnabled: { type: Boolean, required: true }
  },
  data () {
    return {
      invert: false,
      checked: this.conversionKitEnabled
    }
  },
  watch: {
    checked (checked) {
      this.$emit('change', checked)
    },
    conversionKitEnabled (state) {
      this.invert = state
      if (this.checked !== state) this.checked = state
    }
  },
  methods: {
    handleChange () {
      if (!this.checked) return
      setTimeout(() => {
        this.$scrollTo('#top')
      }, 600)
    },
    invertDesign () {
      const isInverted = this.invert
      this.invert = !isInverted
      setTimeout(() => {
        this.invert = isInverted
      }, 1000)
    }
  }
}
